module.exports = __webpack_public_path__ + "static/media/1.10_preview.4c48e906.png";